class Newsletter {

  /* ========================================================================
   * Newsletters.js
   * ======================================================================== */
  constructor( el,user ) {
    this.el = el;
    this.user = user
    this.fieldHidden = null;
    this.infos = Object.assign({
      "sitekey" : null,
      "maindomain": null
    }, ( document.body.dataset.pagedatas? JSON.parse( document.body.dataset.pagedatas ) : {} ) );

    this.options = Object.assign({
      name: null,
      isabo: false,
      field: null,
      extrafield:null
    }, el.dataset );
  }



  async init(){
    let newsletter = this;
 
    newsletter.el.addEventListener( 'click', (e) => {
      e.preventDefault();
      let success = false;

      if(this.infos.sitekey != ""){
        newsletter.recaptcha();
      }
      
      if(document.getElementById('field-'+newsletter.options.field))
      {
        newsletter.fieldHidden = document.getElementById('field-'+newsletter.options.field);

        // partie abo 
        if(newsletter.el.classList.contains('toabo')){
            window.open(newsletter.el.href, '_blank');
        }
        else if(newsletter.el.classList.contains('unabo')){
            newsletter.updateOptin(1); 
        }
        //partie abo
        else if(newsletter.el.classList.contains('isabo')){
          newsletter.popinConfirmNl();
        }
        else if(newsletter.el.classList.contains('toregister') || newsletter.el.classList.contains('unsub')){
          
          if(document.getElementById('email').value == '' || newsletter.options.extrafield)
          {
           
            document.getElementById('popin-inscription').classList.remove('d-none');

          
            if(newsletter.options.extrafield)
            {
              document.querySelector("#popin-inscription #attr-"+newsletter.options.extrafield).classList.remove('d-none');
            }

            document.querySelector('#validate-notloggin').addEventListener('click',function(){
              document.querySelectorAll("#popin-inscription .alert-danger").forEach(el => el.remove());
              document.getElementById('email').value = document.getElementById("newemail").value;

              newsletter.updateOptin(1,1);
            });
          }
          else{
            newsletter.updateOptin(1);
          }
      
        }
        else if(newsletter.el.classList.contains('isregister')){
          newsletter.popinConfirmNl();
        }

       

      }

    });
  }

  async popinConfirmNl()
  {
    let newsletter = this;
    let newValue = NaN;
    let success = false;

    let msg = "Êtes-vous sûr de vouloir <b>vous désinscrire de la newsletter "+newsletter.options.name+"</b>";


    if(newsletter.options.isabo == 1)
    {
      msg = "Êtes-vous sûr de vouloir <b>vous désabonner de la "+newsletter.options.name+"</b>";
    }
    let popin = document.createElement( 'div' );
    let parent = document.querySelector('#mesnewslettersv2');
    popin.id = "popin_abo";
    popin.innerHTML = '<div id="popin_abo_container">'+
                        '<div id="popin_abo_title">'+msg+'</div>'+
                          '<div class="popin_abo_info mt-2">'+
                            '<span class="btn accept_unsub me-2">Oui</span><span class="btn abort_unsub">Non</span>'+
                          '</div>'+
                        '</div>';
    parent.append(popin);



    document.querySelector( '.accept_unsub' ).addEventListener('click',function(){
      popin.remove();
      newsletter.fieldHidden.value = 0;
      newsletter.updateOptin(0);
        
    });


    document.querySelector( '.abort_unsub' ).addEventListener('click',function(){
      popin.remove();
    });

    
  }

  async recaptcha()
  {

    var siteKey = this.infos.sitekey; // À remplacer pour chaque domaine
    var maindomain = this.infos.maindomain;
    var serverSideOrigin = "https://"+maindomain+"/metrics"; // Changer le domaine
    var action = 'contact';
    var callback = function(score) {
      window.dataLayer = window.dataLayer || [ ];
      dataLayer.push({event: 'recaptcha',recaptchaScore: score,action: action});// Sauvegarde du score dans une variable 
      if(!document.getElementById('score')){
        const elt = document.createElement("input");
        elt.setAttribute('type','hidden');
        elt.setAttribute('id','score');
        elt.setAttribute('name','score');
        elt.setAttribute('value',score);
        document.getElementById('content-score').appendChild(elt);
      }
    };


    if (window.grecaptcha && typeof window.grecaptcha.ready === 'function') 
    {
      window.grecaptcha.ready(function() {
        window.grecaptcha.execute(siteKey, {action: action})
        .then(function(token) {
          
          var xhr = new XMLHttpRequest();
          xhr.withCredentials = true;
          xhr.open('POST', serverSideOrigin + '/recaptcha?site='+maindomain+'&token=' + token, true);
  
          xhr.onreadystatechange = function() {

            if (xhr.readyState === XMLHttpRequest.DONE) 
            {
              if(xhr.status == 200){
                var response = JSON.parse(xhr.responseText);
                if (response.score) callback(response.score);
              }
              else{
                document.querySelectorAll(".alert-danger").forEach(el => el.remove());

                const elt = document.createElement('div');
                elt.setAttribute('class','alert alert-danger')
                elt.textContent = 'Erreur de sécurité';
                document.getElementById('alerts').prepend(elt);
              }

            }

          };
          xhr.send();
        });
      });
    }
  }

  async updateOptin(value,popinopen = false){
    let field = this;

    let otherAttr = {};
    let userAttr  = {};

    [... document.querySelectorAll(".user_attr")].map( attr => {
      if(attr.value != ""){
        userAttr[attr.getAttribute('name')] = attr.value;
      }
    });
  
    [... document.querySelectorAll(".other_attr")].map( attr => {
      if(attr.value){
        otherAttr[attr.getAttribute('name')] = attr.value;
      }
    });


     fetch( '/compte/update-option', {
      cache: "no-store",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        code:field.options.field,
        value:value,
        origin:document.getElementById('origin').value,
        email: document.getElementById('email').value,
        other_attr:otherAttr,
        user_attr:userAttr,
        score:(document.getElementById('score')) ? document.getElementById('score').value : null
      }),
    }).then( (response) => {
      return response.json();
    }).then( (responseoption) => {
      if(responseoption.success == 1){
        if(value == 1){
          if(field.el.classList.contains('toregister') || field.el.classList.contains('unsub')){
            field.el.classList.remove('toregister');
            field.el.classList.remove('unsub');
            field.el.classList.add('isregister');
          }

          if(field.el.classList.contains('toabo') || field.el.classList.contains('unabo')){
            field.el.classList.remove('toabo');
            field.el.classList.remove('unabo');
            field.el.classList.add('isabo');
          }

        }
        else{
          if(field.el.classList.contains('isregister')){
            field.el.classList.add('unsub');
            field.el.classList.remove('isregister');
          }

          if(field.el.classList.contains('isabo')){
            field.el.classList.add('unabo');
            field.el.classList.remove('isabo');
          }   
          
        }
        field.fieldHidden.value = value;

        if(popinopen == 1){
          document.querySelector('#email').value = document.querySelector('#newemail').value;
          if(field.options.extrafield)
          {
            document.querySelector("#popin-inscription #attr-"+field.options.extrafield).classList.add('d-none');
          }
          document.getElementById('popin-inscription').classList.add('d-none');
        }
        
      }
      else{
        let alert = document.createElement('div');
        alert.setAttribute('class','alert alert-danger')
        alert.textContent = responseoption.msg;
        document.getElementById('formnl').prepend(alert);
      }
      resolve();
    }).catch( () => {
      let alert = document.createElement('div');
      alert.setAttribute('class','alert alert-danger')
      alert.textContent =  'Erreur enregistrement newsletters';
      document.getElementById('formnl').prepend(alert);

    });
  }
}

currentuser.onUserLoad( (e) => {

  let user = e.detail.userinfos;

  [... document.querySelectorAll('.nl-action')].map( nl => {
    let newsletter = new Newsletter(nl,user);
    newsletter.init();
  });

  document.querySelector('#popin-inscription .popin-inscription-close').addEventListener('click',function(){
    document.getElementById('popin-inscription').classList.add('d-none');
  });


  document.querySelector('#newemail').addEventListener('focusin',function(){
    document.querySelector('#popin-inscription .text-cnil').style.display = 'block';
  });

  document.querySelector('#newemail').addEventListener('focusout',function(){
    document.querySelector('#popin-inscription .text-cnil').style.display = 'none';
  });

  [... document.querySelectorAll('.nl-filter .btn')].map( filter => {
    filter.addEventListener('click',function(){
      if(this.classList.contains('nl-abo')){
        document.querySelector('.nl-filter .nl-all').classList.remove('active');
        document.querySelector('.nl-filter .nl-abo').classList.add('active');
        document.querySelector('#nl-all').style.display = 'none';
        document.querySelector('#nl-abo').style.display = 'grid';
      }
      else{
        document.querySelector('.nl-filter .nl-all').classList.add('active');
        document.querySelector('.nl-filter .nl-abo').classList.remove('active');
        document.querySelector('#nl-all').style.display = 'grid';
        document.querySelector('#nl-abo').style.display = 'grid';
      }
    });
  
  });
});
